// Global Instructions Rule Applied!
// Standalone route wrapper for the Interest Accruals workbench
// (/interest-accruals): fund selector enabled. The Fund form embeds the same
// component with the fund fixed.
import React from 'react'
import InterestAccrualsWorkbench from './InterestAccrualsWorkbench.tsx'

export default function InterestAccrualsPage() {
  return <InterestAccrualsWorkbench />
}
